/**
 * Cele doua feluri de activitate care se depun prin linkul de colaborator, si tot ce le deosebeste
 * pe ecran. Pur (fara React), ca gruparea sa fie testabila in vitest.
 */
export type TipColab = 'PRACTICAL_ACTIVITY' | 'CLASS_EXERCISE';

export interface ConfigTipColab {
    tip: TipColab;
    /** Titlul sectiunii din lista. */
    titluSectiune: string;
    /** Eticheta de pe card si de pe ecranul de detalii (singular). */
    eticheta: string;
    /** O propozitie sub titlul sectiunii: ce este si ce se trimite. */
    explicatie: string;
    /** Textul afisat cand sectiunea n-are nimic deschis. */
    gol: string;
    /** Pasii de urmat, pe ecranul de detalii. */
    pasi: string[];
    /** Butonul din josul ecranului de detalii si titlul pasului de fisiere. */
    butonTrimite: string;
    titluFisiere: string;
    indicatieFisiere: string;
    titluTrimis: string;
}

export const TIPURI_COLAB: readonly ConfigTipColab[] = [
    {
        tip: 'PRACTICAL_ACTIVITY',
        titluSectiune: 'Activități practice',
        eticheta: 'Activitate practică',
        explicatie: 'Acțiuni organizate cu elevii. Trimiți poze și clasele care au participat.',
        gol: 'Nu există activități practice deschise în acest moment.',
        pasi: [
            'Citește descrierea și organizează activitatea cu elevii.',
            'Fă câteva poze în timpul activității.',
            'Trimite pozele și clasele participante. Punctele se acordă școlii după aprobare.',
        ],
        butonTrimite: 'Trimite dovezile',
        titluFisiere: 'Dovezi',
        indicatieFisiere: 'Poze din timpul activității sau PDF, maximum 5.',
        titluTrimis: 'Activitate trimisă',
    },
    {
        tip: 'CLASS_EXERCISE',
        titluSectiune: 'Exerciții cu clasa',
        eticheta: 'Exercițiu cu clasa',
        explicatie: 'Lecții cu film și fișă de lucru. Trimiți pozele fișelor completate de elevi.',
        gol: 'Nu există exerciții cu clasa deschise în acest moment.',
        pasi: [
            'Urmărește filmul împreună cu elevii.',
            'Descarcă și tipărește fișa de exerciții. Elevii o completează în clasă.',
            'Fotografiază fișele completate și trimite-le de aici, împreună cu numărul de elevi care au participat. Echipa ECOTIC numără fișele la aprobare.',
        ],
        butonTrimite: 'Trimite fișele completate',
        titluFisiere: 'Fișele completate',
        indicatieFisiere: 'Poze cu fișele completate sau PDF, maximum 5.',
        titluTrimis: 'Fișe trimise',
    },
];

export function configTip(tip: string | null | undefined): ConfigTipColab {
    return TIPURI_COLAB.find((c) => c.tip === tip) ?? TIPURI_COLAB[0];
}

export function esteTipColab(tip: unknown): tip is TipColab {
    return tip === 'PRACTICAL_ACTIVITY' || tip === 'CLASS_EXERCISE';
}

export interface GrupActivitati<T> extends ConfigTipColab {
    activitati: T[];
}

/**
 * Activitatile linkului, pe sectiuni, in ordinea fixa din {@link TIPURI_COLAB} si cu ordinea din
 * fiecare tip pastrata (o da serverul). Ambele sectiuni exista mereu, si goale: colaboratorul
 * trebuie sa vada ca exista doua feluri de lucruri de raportat. Un tip necunoscut nu se afiseaza.
 */
export function grupeazaActivitati<T extends { type?: string | null }>(activitati: readonly T[] | null | undefined): GrupActivitati<T>[] {
    return TIPURI_COLAB.map((cfg) => ({
        ...cfg,
        activitati: (activitati ?? []).filter((a) => a.type === cfg.tip),
    }));
}
